import { TeamsService } from '@teams/infra';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AcceptTeamInvitationPathParams } from '@core-http';

export class JoinToTeamCommandHandler {
  private readonly teamsService: TeamsService = inject(TeamsService);

  join(teamId: string, token: string): Observable<void> {
    const pathParams: AcceptTeamInvitationPathParams = { teamId };

    return this.teamsService.joinToTeam(pathParams, token);
  }
}
